import type { DocumentsAndRequestsFeatureConfig } from '../type';

export const documentsAndRequests: Partial<DocumentsAndRequestsFeatureConfig> = {
    displayCaseId: false,
    displayCaseType: true,
    documentsPackageDownload: true,
    overviewFilterText: true,
    overviewFilterCaseType: true,
    overviewFilterCaseStatus: true,
    overviewFilterCaseStatuses: [
        'FOR_SIGNING',
        'SIGNED',
        'REJECTED',
        'FOR_DISPLAY',
        'DISPLAYED',
        'CANCELLED',
        'EXPIRED',
    ],
};
